import { useQuery } from 'react-query';
import { HOOKS_SETTINGS } from '../constants';
import { BASE_URL, USER } from '../../constants/endpoints';
import { httpService } from '../../services/http.service';
import { NEW_CARD_ORDER_REASONS } from '../../flows/liliCard/constants';

const { METHOD: { POST, GET } } = HOOKS_SETTINGS;
const { R_LOST, R_STOLEN, R_DAMAGED } = NEW_CARD_ORDER_REASONS;
const { CONTROLLERS: { ORDER_NEW_CARD: { BASE, VERSION } } } = USER;
export const useOrderNewCardQuery = ({
  customerId, cardId, reason, onSuccess, onError,
}: {customerId:string, cardId:string, reason:string, onSuccess?: () => void, onError?: (err: any) => void }) => useQuery(
  ['orderNewCard'],
  async () => {
    if (!customerId || !cardId) {
      return '';
    }
    const query = reason === R_LOST || reason === R_STOLEN ? `cancel?reason=${reason}` : 'replace';

    const { data } = await httpService({
      url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/${cardId}/${query}`,
      method: reason === R_DAMAGED ? POST : GET,
    });
    return data;
  },
  {
    enabled: false,
    retry: 0,
    onSuccess: () => { if (onSuccess) onSuccess(); },
    onError: (err) => { if (onError) onError(err); },
  },
);
